import React from 'react';
import { useWizard } from '@wkda/funnel-components';
import { debounce } from 'lodash-es';
var DOM_IDLE_WAIT_MS = 800;
var FunnelMessageEvent = {
  WIZARD_STEP_CHANGE: 'WIZARD_STEP_CHANGE'
};
function useWaitUntilDOMIdle() {
  var hasMutatedRef = React.useRef(false);
  function wait(node) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DOM_IDLE_WAIT_MS;
    return new Promise(function (resolve) {
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };

      /**
       * If we haven't received any mutation for given time, resolve promise anyway.
       */
      var timeoutId = setTimeout(function () {
        if (!hasMutatedRef.current) {
          observer.disconnect();
          hasMutatedRef.current = false;
          resolve();
        }
      }, wait);
      var observer = new MutationObserver(debounce(function (_, observer) {
        observer.disconnect();
        clearTimeout(timeoutId);
        hasMutatedRef.current = true;
        resolve();
      }, wait, {
        leading: false,
        trailing: true
      }));
      observer.observe(node, config);
    });
  }
  return wait;
}
function PartnerEventManager() {
  var _useWizard = useWizard(),
    currentStep = _useWizard.currentStep,
    totalSteps = _useWizard.totalSteps,
    savedSteps = _useWizard.savedSteps,
    status = _useWizard.status;
  var waitUntilDOMIdle = useWaitUntilDOMIdle();
  function postPartnerMessage(event, payload) {
    window.parent.postMessage({
      event: event,
      payload: payload
    }, '*');
  }
  React.useEffect(function () {
    if (typeof window === 'undefined' || window.parent === window.self || status === 'loading' || status === 'loadingFailed') {
      return;
    }

    /**
     * @type {HTMLElement | null}
     */
    var targetElement = document.querySelector("#step-" + (currentStep + 1)) || document.querySelector('body');
    waitUntilDOMIdle(targetElement).then(function () {
      var _targetElement$getBou = targetElement.getBoundingClientRect(),
        x = _targetElement$getBou.x,
        y = _targetElement$getBou.y;
      postPartnerMessage(FunnelMessageEvent.WIZARD_STEP_CHANGE, {
        currentStep: currentStep,
        totalSteps: totalSteps,
        savedSteps: savedSteps,
        element: {
          pos: {
            x: x,
            y: y
          }
        }
      });
    });
  }, [currentStep, status]);
  return null;
}
export default /*#__PURE__*/React.memo(PartnerEventManager);